import React, { PureComponent } from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import fp from 'lodash/fp';
import { withRouter } from 'react-router';
import { withPropsOnChange } from 'recompose';
import { Spinner, Alert } from '@deerplusofficial/pos-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const Wrapper = styled.div`
  margin: auto;
  text-align: center;
`;

class Payments extends PureComponent {
  state = {
    error: false,
  };

  componentDidMount() {
    const { type, url } = this.props;

    if (type !== '102' || _.isNil(url)) {
      Alert.fire({ type: 'error', titleText: 'Undefined payment method.' });
      this.setState({ error: true });
      return;
    }

    window.location.href = url;
  }

  render() {
    const { error } = this.state;

    if (error) return null;

    return (
      <Container>
        <Wrapper>
          <Spinner dark />
          <p>跳轉中，請稍候</p>
        </Wrapper>
      </Container>
    );
  }
}

export default fp.compose(
  withRouter,
  withPropsOnChange(['location'], ({ location }) => {
    const params = new URLSearchParams(location.search);

    return {
      url: params.get('url'),
      type: params.get('type'),
    };
  })
)(Payments);



// WEBPACK FOOTER //
// ./src/pages/Payments/Payments.js